const KEYS = {
  LEADS_COUNT: 'leads-count',
  TOTAL_SALES: 'total-sales',
  TOP_PRODUCTS: 'top-products',
};

export default { ...KEYS };
